import { toFormat } from "@/lib/dateHelpers";

export function formatPastPresidentsElectionSummary(
  runs: { startedAt: string; completedAt?: string | null }[]
): string {
  if (runs.length === 1) {
    const run = runs[0];
    const started = toFormat(run.startedAt, "MMM dd, yyyy h:mm a");
    const completed = run.completedAt ? toFormat(run.completedAt, "MMM dd, yyyy h:mm a") : null;
    return `Election run started ${started ?? ""}${completed ? `, completed ${completed}` : ""}. Adjust Past Presidents below, then download the roster.`;
  }
  return `${runs.length} completed election runs will be merged into one roster. Adjust Past Presidents below, then download.`;
}
